import { Component } from "react";
import { Container } from "react-bootstrap";

export class Footer extends Component{
    render(){
        return <footer>
            <Container style={{textAlign: 'center'}}>
                <div>&copy;2023 - Bernard Healthcare. All rights reserved.</div>
            </Container>
        </footer>
    }
}